const listeners = new Set();

export const subscribeApiSuccess = (listener) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

export const notifyApiSuccess = (apiPath) => {
  listeners.forEach((listener) => {
    try {
      listener(apiPath);
    } catch (error) {
      // Listeners must never break the original API call.
    }
  });
};

export const isAnnouncementApiPath = (apiPath) =>
  String(apiPath || "")
    .replace(/^\//, "")
    .startsWith("announcements");
